module.exports = __webpack_public_path__ + "media/images/feder-39e57c05fc23afb78b8ff22df97fd306.jpg";